module.exports = __webpack_public_path__ + "static/media/PopcornBucket.44669d3c.glb";